<template>
  <div
    class="editor editor__content editor__page"
    v-html="translate(text)"
    v-if="translate(text)"
  />
</template>

<script setup>
import { useI18n } from '@/vendors/i18n'
import { useStyle } from '@/composables/app/useStyle'

const { parent, component } = defineProps({
  parent: { type: Object, required: true },
  component: { type: Object, required: true }
})

const { componentStyle: parentStyle } = useStyle(parent.style)
const { componentStyle: blockStyle } = useStyle(component.style)
const { translate } = useI18n()

const { text } = component.attributes
const color = blockStyle.value.color || parentStyle.value.color
</script>

<style lang="scss" scoped>
.editor {
  color: v-bind(color);
}
</style>
